import { getSfChainName } from "../helpers/sf";
import { ADDRESSES, ASSET_TOKENS_PAIRS } from "./constants";

function getSuperfluidResolverAddr(chainId) {
  // should never be able to call this with an invalid chainId
  return ADDRESSES[chainId].ADDRESS_SUPERFLUID_RESOLVER;
}

function isSupportedNetwork(chainId) {
  // TODO: this should link w/ index.js and get the values from some common config
  // NOTE: this is related to the chainId for the config - which is loosely tied to the index.js/network config
  chainId = String(chainId);

  return Object.keys(ADDRESSES).includes(chainId);
}

function getDcaPoolContracts(chainId) {
  if (chainId in ASSET_TOKENS_PAIRS) return ASSET_TOKENS_PAIRS[chainId];
  else return {};
}

function isSupportedPair(chainId, sourceToken, targetToken) {
  const pairs = getDcaPoolContracts(chainId);
  return targetToken in pairs && sourceToken in pairs[targetToken];
}

function getDcaPoolContractAddr(chainId, sourceToken, targetToken) {
  // ATTN: should never be able to call this with invalid arguments

  return getDcaPoolContracts(chainId)[targetToken][sourceToken].contractAddress;
}

function getDcaPoolIdx(chainId, sourceToken, targetToken) {
  // ATTN: should never be able to call this with invalid arguments

  return getDcaPoolContracts(chainId)[targetToken][sourceToken].index;
}

function getForwarderAddr(chainId) {
  return ADDRESSES[chainId].ADDRESS_SUPERFLUID_CFA_V1_FORWARDER;
}

function getSuperfluidConsoleLink(chainId, account) {
  return "https://console.superfluid.finance/" + getSfChainName(chainId) + "/accounts/" + account + "?tab=streams";
}

function getExplorerTxLink(chain, txHash) {
  return chain.blockExplorers?.default.url + "/tx/" + txHash;
}

function getExplorerAddressLink(chain, address) {
  return chain.blockExplorers?.default.url + "/address/" + address;
}

export {
  isSupportedNetwork,
  isSupportedPair,
  getSuperfluidResolverAddr,
  getDcaPoolContracts,
  getDcaPoolContractAddr,
  getDcaPoolIdx,
  getForwarderAddr,
  getSuperfluidConsoleLink,
  getExplorerTxLink,
  getExplorerAddressLink,
};
